import { render, staticRenderFns } from "./IndicatorDisplay3.vue?vue&type=template&id=628cee15&scoped=true&"
import script from "./IndicatorDisplay3.vue?vue&type=script&lang=js&"
export * from "./IndicatorDisplay3.vue?vue&type=script&lang=js&"
import style0 from "./IndicatorDisplay3.vue?vue&type=style&index=0&id=628cee15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628cee15",
  null
  
)

export default component.exports